import React from "react";
import "./sidebar.scss";
import VellmartLogo from "../../images/logos/vellmartLogo.svg";
import DesktopMenu from "../desctopMenu/DesctopMenu";
import LangSelector from "../langSelector/LangSelector";
import { useNavigate } from "react-router-dom";

const Sidebar = () => {
    const navigane = useNavigate();
    return (
        <div className="sidebar">
            <img src={VellmartLogo} alt="Vellmart" className="sidebar__logo" onClick={() => navigane("/dashboard")} />
            <DesktopMenu />
            <div className="sidebar__lang-selector">
                <LangSelector />
            </div>
        </div>
    );
};

export default Sidebar;
